/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Balance from './Balance';

/**
 * The SettlementControllerDtoDoSettlementRequiredTransaction model module.
 * @module model/SettlementControllerDtoDoSettlementRequiredTransaction
 * @version 1.0
 */
class SettlementControllerDtoDoSettlementRequiredTransaction {
    /**
     * Constructs a new <code>SettlementControllerDtoDoSettlementRequiredTransaction</code>.
     * @alias module:model/SettlementControllerDtoDoSettlementRequiredTransaction
     */
    constructor() { 
        
        SettlementControllerDtoDoSettlementRequiredTransaction.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SettlementControllerDtoDoSettlementRequiredTransaction</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SettlementControllerDtoDoSettlementRequiredTransaction} obj Optional instance to populate.
     * @return {module:model/SettlementControllerDtoDoSettlementRequiredTransaction} The populated <code>SettlementControllerDtoDoSettlementRequiredTransaction</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SettlementControllerDtoDoSettlementRequiredTransaction();

            if (data.hasOwnProperty('current')) {
                obj['current'] = Balance.constructFromObject(data['current']);
            }
            if (data.hasOwnProperty('afterSettlement')) {
                obj['afterSettlement'] = Balance.constructFromObject(data['afterSettlement']);
            }
            if (data.hasOwnProperty('settlement')) {
                obj['settlement'] = Balance.constructFromObject(data['settlement']);
            }
            if (data.hasOwnProperty('minimumRequirementToTransfer')) {
                obj['minimumRequirementToTransfer'] = Balance.constructFromObject(data['minimumRequirementToTransfer']);
            }
            if (data.hasOwnProperty('available')) {
                obj['available'] = Balance.constructFromObject(data['available']);
            }
            if (data.hasOwnProperty('nonTransferable')) {
                obj['nonTransferable'] = Balance.constructFromObject(data['nonTransferable']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SettlementControllerDtoDoSettlementRequiredTransaction</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SettlementControllerDtoDoSettlementRequiredTransaction</code>.
     */
    static validateJSON(data) {
        // validate the optional field `current`
        if (data['current']) { // data not null
          Balance.validateJSON(data['current']);
        }
        // validate the optional field `afterSettlement`
        if (data['afterSettlement']) { // data not null
          Balance.validateJSON(data['afterSettlement']);
        }
        // validate the optional field `settlement`
        if (data['settlement']) { // data not null
          Balance.validateJSON(data['settlement']);
        }
        // validate the optional field `minimumRequirementToTransfer`
        if (data['minimumRequirementToTransfer']) { // data not null
          Balance.validateJSON(data['minimumRequirementToTransfer']);
        }
        // validate the optional field `available`
        if (data['available']) { // data not null
          Balance.validateJSON(data['available']);
        }
        // validate the optional field `nonTransferable`
        if (data['nonTransferable']) { // data not null
          Balance.validateJSON(data['nonTransferable']);
        }

        return true;
    }


}



/**
 * @member {module:model/Balance} current
 */
SettlementControllerDtoDoSettlementRequiredTransaction.prototype['current'] = undefined;

/**
 * @member {module:model/Balance} afterSettlement
 */
SettlementControllerDtoDoSettlementRequiredTransaction.prototype['afterSettlement'] = undefined;

/**
 * @member {module:model/Balance} settlement
 */
SettlementControllerDtoDoSettlementRequiredTransaction.prototype['settlement'] = undefined;

/**
 * @member {module:model/Balance} minimumRequirementToTransfer
 */
SettlementControllerDtoDoSettlementRequiredTransaction.prototype['minimumRequirementToTransfer'] = undefined;

/**
 * @member {module:model/Balance} available
 */
SettlementControllerDtoDoSettlementRequiredTransaction.prototype['available'] = undefined;

/**
 * @member {module:model/Balance} nonTransferable
 */
SettlementControllerDtoDoSettlementRequiredTransaction.prototype['nonTransferable'] = undefined;






export default SettlementControllerDtoDoSettlementRequiredTransaction;

